import { ModelValue, ViewModelFieldName } from "../../CoreTypes";
import { AbsoluteResolvedModelPath } from "../../../../../../Common/ModelPath/ModelPath";
import { Action } from "../../../../../../Common/Funcs";
import { AbsoluteModelFieldPath } from "../../../../../../Common/ModelPath/AbsoluteModelFieldPath";

export type ModelEventType = "change" | "remove";

export interface ModelEvent {
    readonly type: ModelEventType;
    readonly value?: ModelValue;
    readonly name?: ViewModelFieldName;
    readonly path: AbsoluteResolvedModelPath;
    readonly fullPath?: AbsoluteModelFieldPath;
    readonly oldValue?: ModelValue;

    processedBySum?: boolean;
}

export function createRemoveModelEventInfo(
    path: AbsoluteResolvedModelPath,
    name?: ViewModelFieldName,
    oldValue?: ModelValue
): ModelEvent {
    if (name == undefined) {
        return { type: "remove", path: path };
    }
    if (oldValue === undefined) {
        return {
            type: "remove",
            path: path,
            name: name,
            fullPath: new AbsoluteModelFieldPath(path, name),
        };
    }
    return {
        type: "remove",
        path: path,
        name: name,
        fullPath: new AbsoluteModelFieldPath(path, name),
        oldValue: oldValue,
    };
}

export function createChangeModelEventInfo(
    path: AbsoluteResolvedModelPath,
    name: ViewModelFieldName,
    oldValue: ModelValue,
    value: ModelValue
): ModelEvent {
    if (oldValue === undefined) {
        return {
            type: "change",
            path: path,
            name: name,
            fullPath: new AbsoluteModelFieldPath(path, name),
            value: value,
        };
    }
    return {
        type: "change",
        path: path,
        name: name,
        fullPath: new AbsoluteModelFieldPath(path, name),
        value: value,
        oldValue: oldValue,
    };
}

export type ModelEventsListener = Action<ModelEvent>;

export function isChangeModelEventInfo(event: ModelEvent): boolean {
    return event.type === "change";
}

export function isRemoveModelEventInfo(event: ModelEvent): boolean {
    return event.type === "remove";
}

export function patchModelEventInfo(event: ModelEvent, updateFunction: (ev: ModelEvent) => void): void {
    updateFunction(event);
}

export function isModelEventInfo(eventData: unknown): eventData is ModelEvent {
    return (
        typeof eventData === "object" &&
        eventData != undefined &&
        "type" in eventData &&
        (eventData["type"] === "change" || eventData["type"] === "remove")
    );
}

export function isChangeViewModelEvent(event: ModelEvent): boolean {
    return event.name === "value" || event.name === "children";
}
